import React from 'react';

const CustomizePageContext = React.createContext({});

export default CustomizePageContext;
